/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Copilot_Placeholder1Inputs */

const zh_landing_copilot_placeholder1 = /** @type {(inputs: Landing_Copilot_Placeholder1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`生成一节 45 分钟的二次函数变换教案`)
};

const en_landing_copilot_placeholder1 = /** @type {(inputs: Landing_Copilot_Placeholder1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Generate a 45-minute lesson plan on quadratic transformations`)
};

const es_landing_copilot_placeholder1 = /** @type {(inputs: Landing_Copilot_Placeholder1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Genera un plan de clase de 45 minutos sobre transformaciones cuadráticas`)
};

/**
* | output |
* | --- |
* | "Generate a 45-minute lesson plan on quadratic transformations" |
*
* @param {Landing_Copilot_Placeholder1Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
export const landing_copilot_placeholder1 = /** @type {((inputs?: Landing_Copilot_Placeholder1Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Copilot_Placeholder1Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_landing_copilot_placeholder1(inputs)
	if (locale === "en") return en_landing_copilot_placeholder1(inputs)
	return es_landing_copilot_placeholder1(inputs)
});